import React, { useState } from "react";
import { BrowserRouter as Router, Switch, Link } from "react-router-dom";
import { axiosAuth } from "@dreamchimney/react-axios";
import environment from "environment";
import Analytics from "./Components/Analytics/Analytics";

import "./css/global.less";
import "./css/layout.less";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";

import HomePage from "./Pages/Home/HomePage";
import BrowseAllPage from "./Pages/Sleeves/BrowseAllPage";
import ScrollToTop from "./Components/Global/ScrollToTop";
import DevBanner from "./Components/Global/DevBanner";

import AboutPage from "./Pages/About/AboutPage";
import DetailPage from "./Pages/Sleeves/DetailPage";
import TagListPage from "./Pages/Search/TagListPage";
import SearchPage from "./Pages/Search/SearchPage";
import UserPage from "./Pages/Search/UserPage";
import AddSleevePage from "./Pages/Sleeves/AddSleevePage";
import LoginModal from "@dreamchimney/user-login";
import { useUser, AuthWrapper } from "@dreamchimney/user-context";

import Route from "./Components/Global/RouteWithMiddle";
import EditSleevePage from "./Pages/Sleeves/EditSleevePage";
import UserFavoritesPage from "./Pages/Search/UserFavoritesPage";
import PopularPage from "./Pages/Search/PopularPage";
import PopularCommentsPage from "./Pages/Search/PopularCommentsPage";
import SiteFooter from "./Components/Global/SiteFooter";
import { setSleeveIsFavorite } from "./api/getSleeves";

const NoMatchPage = () => {
  return (
    <div style={{ margin: "40px" }}>
      <h3>Bummer... Page Not Found.</h3>

      <p>
        <Link to="/">Back to Home</Link>
      </p>
    </div>
  );
};

const features = {
  MSG_WELCOME_FAV: `sleevery-welcome-fav`,
};

const App = () => {
  const { state: userState, dispatch } = useUser();

  const loginToggle = () => dispatch({ type: "signin_open" });
  const modalClosed = () => dispatch({ type: "signin_close" });
  const [welcomeMsgFavorites, setWelcomeMsgFavorites] = useState(localStorage.getItem(features.MSG_WELCOME_FAV) || false);

  const handleWelcomeFavDismiss = (e) => {
    localStorage.setItem(features.MSG_WELCOME_FAV, false);
    setWelcomeMsgFavorites(true);
  };
  const handleLoginAction = (payload) => {
    const { dispatch: payloadDispatch = {} } = payload;
    const promiseActions = [];

    // Add sleeve favorite after login/register
    const loginSetSleeveFav = localStorage.getItem("login_sleeve_fav") || false;
    if (loginSetSleeveFav) {
      const setFavSleeve = setSleeveIsFavorite(axiosAuth, loginSetSleeveFav).then((data) => localStorage.removeItem("login_sleeve_fav"));
      promiseActions.push(setFavSleeve);
    }

    Promise.all(promiseActions).then((values) => {
      dispatch(payloadDispatch);
    });
  };

  return (
    <div className="app-sleevery">
      <DevBanner />

      <Router basename="/sleevery">

        <AuthWrapper>
          <Container className="app-container" fluid={false}>
            <Row>
              <Col xs={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
                <header>
                  <h1>
                    <Link to="/">Sleevery</Link>
                  </h1>
                </header>
              </Col>
            </Row>
            {userState.loggedin && !welcomeMsgFavorites && (
              <Row>
                <Col xs={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <Alert variant={"warning"} onClose={handleWelcomeFavDismiss} dismissible>
                    Welcome! Add sleeves to your favorites with the <i className="far fa-heart"></i> icon. View your{" "}
                    <Link to={`/sleeves/favorites/${userState.user.dir}`}>favorites</Link> or{" "}
                    <Link to={`/sleeves/popular`}>most popular</Link> sleeves.
                  </Alert>
                </Col>
              </Row>
            )}

            <Analytics basename="/sleevery" local={environment.isDevelopment}>
              <ScrollToTop />

              <Switch>
                <Route exact path="/" name="home" component={HomePage} />
                <Route exact path="/sleeves/view/:id(\d+)" name="detail" keyId="id" component={DetailPage} />
                <Route exact path="/sleeves/list" name="browseAll" component={BrowseAllPage} />
                <Route exact path="/tag/:tag" name="tag" keyId="tag" component={TagListPage} />
                <Route exact path="/search" name="search" keyId="find" component={SearchPage} />
                <Route exact path="/sleeves/popular" name="popular" component={PopularPage} />
                <Route exact path="/sleeves/comments" name="comments" component={PopularCommentsPage} />
                <Route exact path="/sleeves/by/:chimdir" name="byuser" component={UserPage} />
                <Route exact path="/sleeves/favorites/:chimdir" name="favs" component={UserFavoritesPage} />
                <Route chimOnly withNav={false} exact path="/sleeve/add" name="add" component={AddSleevePage} />
                <Route withNav={false} exact path="/sleeve/edit/:id(\d+)" name="edit" keyId="id" component={EditSleevePage} />
                <Route exact path="/about" name="about" component={AboutPage} />

                <Route path="*">
                  <NoMatchPage />
                </Route>
              </Switch>
            </Analytics>
          </Container>
        </AuthWrapper>
      </Router>

      <LoginModal
        show={userState.signin}
        show_fav={userState.signin_show_fav}
        onClose={modalClosed}
        onLoggedin={handleLoginAction}
        onRegister={handleLoginAction}
      />
      <SiteFooter />
    </div>
  );
};

export default App;
